import summaryCommonStore from "@/store/summaryCommon.store";
import Tooltip from "@/component/Tooltip";
import FocusIcon from "@/assets/summary/ic_focus.svg?react";

interface IOriginTextAnchorProps {
  className?: string;
  showToolTip?: boolean;
}
function OriginTextAnchor({
  className,
  showToolTip = true,
}: IOriginTextAnchorProps) {
  const isScrolled = summaryCommonStore((state) => state.isScrolled);
  const isFollowMode = summaryCommonStore((state) => state.isFollowMode);

  const show = isScrolled && !isFollowMode;

  const handleClick = () => {
    summaryCommonStore.getState().setIsScrolled(false);
  };

  return showToolTip ? (
    <Tooltip hover content={"回到当前播放位置"}>
      <div
        className={`${
          !show ? "hidden" : "flex"
        } ${className} absolute size-10 rounded-full bg-#fff b-1 b-solid b-#ECEEF3 items-center justify-center cursor-pointer will-change-transform `}
      >
        <FocusIcon onClick={handleClick} />
      </div>
    </Tooltip>
  ) : (
    <div
      className={`${
        !show ? "hidden" : "flex"
      } ${className} absolute size-10 rounded-full bg-#fff b-1 b-solid b-#ECEEF3 items-center justify-center cursor-pointer will-change-transform `}
    >
      <FocusIcon onClick={handleClick} />
    </div>
  );
}

export default OriginTextAnchor;
